import React, { useCallback, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown";
import {
  changeResultsFilters,
  selectChosenFlightsResults,
  selectResultsFilters,
} from "../searchFlightsSlice";
import { useOnClickOutside } from "../../../hooks/useOnClickOutside";

function ViaDropdown() {
  const dropdownRef = useRef(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState<boolean>(false);
  const [highlightedIndex, setHighlightedIndex] = useState<number>(0);
  useOnClickOutside(
    dropdownRef,
    useCallback(() => setActive(false), [setActive])
  );
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { via: selected } = useAppSelector(selectResultsFilters);
  const { via } = useAppSelector(selectChosenFlightsResults);

  const options = ["", ...via];

  const onClick = () => {
    setActive(!active);
    if (!active) {
      setHighlightedIndex(options.indexOf(selected));
      setTimeout(() => menuRef.current?.focus(), 0);
    }
  };

  const onSelect = (value: string) => {
    dispatch(changeResultsFilters({ via: value }));
    setActive(!active);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) => (prev + 1) % options.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex(
        (prev) => (prev - 1 + options.length) % options.length
      );
    } else if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onSelect(options[highlightedIndex]);
    } else if (e.key === "Escape") {
      setActive(false);
    }
  };

  if (via.length === 0) {
    return null;
  }
  return (
    <>
      <div className={`dropdown ${active ? " is-active" : ""}`}>
        <div className="dropdown-trigger">
          <button
            className="button"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
            onClick={onClick}
          >
            <span>{t("HEADER_SORT_VIA")}</span>
            <span className="icon">
              <FontAwesomeIcon icon={faAngleDown} aria-hidden="true" />
            </span>
          </button>
        </div>
        <div
          ref={menuRef}
          className="dropdown-menu"
          id="dropdown-menu"
          role="menu"
          tabIndex={-1}
          onKeyDown={handleKeyDown}
        >
          <ul className="dropdown-content">
            <li>
              <a
                onMouseDown={() => onSelect("")}
                onMouseEnter={() => setHighlightedIndex(0)}
                href="#"
                tabIndex={-1}
                className={`dropdown-item${
                  selected === "" ? " is-active" : ""
                }${highlightedIndex === 0 && active ? " is-highlighted" : ""}`}
              >
                {t("NONE")}
              </a>
            </li>
            {via.map((airport, i) => {
              return (
                <li key={i}>
                  <a
                    onMouseDown={() => onSelect(airport)}
                    onMouseEnter={() => setHighlightedIndex(i + 1)}
                    href="#"
                    tabIndex={-1}
                    className={`dropdown-item${
                      selected === airport ? " is-active" : ""
                    }${
                      highlightedIndex === i + 1 && active
                        ? " is-highlighted"
                        : ""
                    }`}
                  >
                    {airport}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        &nbsp;
      </div>
    </>
  );
}

export default ViaDropdown;
